
import withReflex from './withReflex'

// For backwards-compatibility
// This will be deprecated in a later release
const Reflex = withReflex()

export default Reflex

